import { Audio } from './blocks/Audio/Audio.js';
import { Blockquote } from './blocks/Blockquote/Blockquote.js';
import { CodeBlock } from './blocks/CodeBlock/CodeBlock.js';
import { Divider } from './blocks/Divider/Divider.js';
import { Embed } from './blocks/Embed/Embed.js';
import { Image } from './blocks/Image/Image.js';
import { LottieFile } from './blocks/LottieFile/LottieFile.js';
import { TableOfContents } from './blocks/TableOfContents/TableOfContents.js';
import { Video } from './blocks/Video/Video.js';
import { Mention } from './inlineContent/Mention.js';
import { BlockNoteSchema, defaultBlockSpecs, defaultInlineContentSpecs, defaultStyleSpecs, } from '@blocknote/core';
// The schema defines the available blocks, inline content, and styles for the editor,
// including any custom blocks, inline content, and styles that we've added.
const customBlockSpecs = {
    ...defaultBlockSpecs,
    [Audio.config.type]: Audio,
    [Blockquote.config.type]: Blockquote,
    [CodeBlock.config.type]: CodeBlock,
    [Divider.config.type]: Divider,
    [Embed.config.type]: Embed,
    [Image.config.type]: Image,
    [LottieFile.config.type]: LottieFile,
    [TableOfContents.config.type]: TableOfContents,
    [Video.config.type]: Video,
};
const customInlineContentSpecs = {
    ...defaultInlineContentSpecs,
    mention: Mention,
};
const customStyleSpecs = {
    ...defaultStyleSpecs,
};
export const createSchema = (options) => {
    const blockSpecs = {};
    for (const key of Object.keys(customBlockSpecs)) {
        if (key === 'paragraph' || key === 'video' || options.blocks[key]) {
            blockSpecs[key] = customBlockSpecs[key];
        }
    }
    const styleSpecs = {};
    for (const key of Object.keys(customStyleSpecs)) {
        if (options.textStyles[key]) {
            styleSpecs[key] = customStyleSpecs[key];
        }
    }
    const inlineContentSpecs = {
        ...customInlineContentSpecs,
    };
    // Note: we want to narrow the schema down based on the options passed in but
    // this function still needs to return a CustomBlockNoteSchema to avoid type errors.
    return BlockNoteSchema.create({
        blockSpecs,
        inlineContentSpecs,
        styleSpecs,
    });
};
//# sourceMappingURL=schema.js.map